import React, { createContext, useContext, useState, useEffect } from "react";
import { handleAxiosResponseError } from "../utils/handleResponseError";
import axios from "../config/axios";

const RolesContext = createContext();
const SetRolesContext = createContext();

export const useRolesContext = () => {
  return useContext(RolesContext);
};

export const useSetRolesContext = () => {
  return useContext(SetRolesContext);
};

export const RolesProvidor = ({ children }) => {
  const [rolesContext, setRolesContext] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/roles`)
      .then(({ data }) => {
        setRolesContext(data.roles);
      })
      .catch((err) => {
        console.log(handleAxiosResponseError(err));
      });
  }, []);

  return (
    <RolesContext.Provider value={rolesContext}>
      <SetRolesContext.Provider value={setRolesContext}>
        {children}
      </SetRolesContext.Provider>
    </RolesContext.Provider>
  );
};
